import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CandidateListColumnDef, PartyColumnDef, PartyOrCandidateListBase } from './expandable-party-table.model';
import { Observable, of } from 'rxjs';
import { getValueAt } from '@valg-shared/utils/object-utils';
import { EnumService } from '@valg-shared/services/enums/enum.service';
import { TranslateService } from '@ngx-translate/core';
import { CandidateDataLoadState, ListOrganisation, ResultSummaryDto, ResultType } from "@shared/clients/api.generated";
import { WithPropsOfType } from '@valg-shared/forms';
import { ColumnMetadata } from '@valg-shared/components/table/table/column-metadata';

@Component({
  selector: 'valg-dk-expandable-party-list[resultType]',
  templateUrl: './expandable-party-list.component.html',
  styleUrls: [ './expandable-party-list.component.scss' ]
})
export class ExpandablePartyListComponent<T> implements OnInit, OnChanges{
  @Input() data: PartyOrCandidateListBase[] = [];
  @Input() resultType: ResultType = ResultType.NoResults;
  @Input() title = 'parties_table.title';
  @Input() isCandidateList = false;
  @Input() candidateDataLoadState: CandidateDataLoadState = CandidateDataLoadState.NotLoaded
  @Input() isCandidateListTable = false;
  @Input() isElectionArea = false;
  @Input() isMigratedElection = false;
  @Input() resultSummary?: ResultSummaryDto;

  CandidateDataLoadState = CandidateDataLoadState;

  noResultpartyColumnDef: WithPropsOfType<PartyOrCandidateListBase, ColumnMetadata> = {
    ...PartyColumnDef,
    votes: {
      ... PartyColumnDef.votes,
      defaultValueIfNull: ""
    },
    diff: {
      ... PartyColumnDef.diff!,
      defaultValueIfNull: ''
    },
    percentage_diff: {
      ...PartyColumnDef.percentage_diff!,
      defaultValueIfNull: ''
    },

  }

  noResultcandidateColumnDef: WithPropsOfType<PartyOrCandidateListBase, ColumnMetadata> = {
    ...CandidateListColumnDef,
    votes: {
      ... PartyColumnDef.votes,
      defaultValueIfNull: ""
    },
    diff: {
      ... CandidateListColumnDef.diff!,
      defaultValueIfNull: ''
    },
    percentage_diff: {
      ...PartyColumnDef.percentage_diff!,
      defaultValueIfNull: ''
    },
  }

  activeColumnDef: WithPropsOfType<PartyOrCandidateListBase, ColumnMetadata> = this.noResultpartyColumnDef;

  constructor(
    private readonly translate: TranslateService,
    private readonly enumService: EnumService){

  }

  ngOnInit(): void {
    this.setColumnDefinition();
  }
  
  
  
  ngOnChanges(changes: SimpleChanges): void {
  if (
    changes['isCandidateList'] ||
    changes['resultType'] ||
    changes['isMigratedElection'] ||
    changes['isElectionArea']
  ) {
    this.setColumnDefinition();
  }
}

  private setColumnDefinition() {
    this.setPartyColumnDef();
    this.handleDifferenceColumns();
  }


  partyRowDescriptionFunction(value: PartyOrCandidateListBase): Observable<string>{
    let hasSpecifiedPersonalVotes = getValueAt(value, 'hasSpecifiedPersonalVotes');
    let listOrganisation = getValueAt(value, 'listOrganisation');
    let type = this.enumService.translateValue(listOrganisation, 'ListOrganisation');
    if (hasSpecifiedPersonalVotes
      && (listOrganisation === ListOrganisation.StandingInParallel
        || listOrganisation === ListOrganisation.PrioritizedStandingInParallel)) {
      type = this.translate.instant('list_organisation.has_personal_votes', { organisation: type });
    }

    return type === "" || type == ListOrganisation.NotSpecified ? of("")
    : this.translate.get('parties_table.row_description', { type: type });
  }

  private setPartyColumnDef()
  {
    if(this.resultType === ResultType.NoResults){
      this.activeColumnDef = this.isCandidateList ? this.noResultcandidateColumnDef : this.noResultpartyColumnDef;
    }else{
      this.activeColumnDef = this.isCandidateList ? CandidateListColumnDef: PartyColumnDef;
    }

    this.activeColumnDef.title.rowDescriptionFunction = this.partyRowDescriptionFunction.bind(this);
  }


  private handleDifferenceColumns(): void 
  {
    const shouldDisable = this.isMigratedElection && this.isElectionArea;

    if (this.activeColumnDef?.diff) {
      this.activeColumnDef.diff.disable = shouldDisable;
    }

    if (this.activeColumnDef?.percentage_diff) {
      this.activeColumnDef.percentage_diff.disable = shouldDisable;
    }
}


}
